import styled from 'styled-components';
import Color from '@/utils/color';

export const CheckBoxLabelContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  cursor: pointer;
`;
export const CheckBoxLabel = styled.span`
  padding-left: 10px;
`;

export const CheckBoxHelpText = styled.span`
  font-size: small;
  color: ${Color.DarkGrey};
  padding-left: 5px;
`;
